import { tw } from "@sveabank/cc-common";

export type ListVariant = keyof typeof listVariants;

export const listVariants = {
	large: tw`flex flex-col gap-4`,
	small: tw`basis-1/2`,
};

export const bulletVariants = {
	sphere: tw`list-disc`,
	none: tw`list-none`,
};

export type BulletVariant = keyof typeof bulletVariants;

export const listItemVariants = {
	large: tw`mb-4 flex gap-4 align-top font-semibold`,
	small: tw`mb-2 flex items-center gap-2 font-semibold`,
	unstyled: "",
};

export type ListItemVariants = keyof typeof listItemVariants;
